import * as Sentry from '@sentry/browser'

export function captureException(err) {
  return Sentry.captureException(err)
}
